import { dateIsToday, getDateProp, areDatesOneDayApart } from '../global/utils';

export default class Habit {
    constructor(
        data={
            id:-1,
            title:'',
            startDate:'',
            lastUpdated:'',
            durationDays:'',
            streakDates:[],
            currentStreak: 0,
        }
    ) {
        
        this.id = data.id;
        this.title = data.title;
        this.startDate = data.startDate;
        this.lastUpdated = data.lastUpdated;
        this.durationDays = data.durationDays;
        this.streakDates = data.streakDates;
        this.updatedToday = this.setUpdatedToday();
        this.currentStreak = data.currentStreak;
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.title;
    }

    getStartDate() {
        return this.startDate
    }

    getLastUpdated() {
        return this.lastUpdated;
    }

    getDurationDays() {
        return this.durationDays;
    }

    getStreakDates() {
        return this.streakDates;        
    }

    getUpdatedToday() {
        return this.updatedToday;
    }

    getCurrentStreak() {
        return this.currentStreak;
    }

    setUpdatedToday() {
        if ( this.streakDates.length === 0 ) {
            return false;
        }
        
        const latestDate = this.streakDates[0];

        return dateIsToday(
            new Date(latestDate)
        );
    }

    toFormObject() {
        return {
            id: this.id,
            habit_id: this.id,
            title: this.title,
            start_date: getDateProp(this.startDate, 'date'),
            duration_days: this.durationDays,
        }
    }
    
}